var b = /*           */ ((r) => (r.Init = "module-init", r.Processing = "processing", r.Custom = "custom", r))(b || {}), W = /*           */ ((r) => (r.CmpInit = "cmp-init", r.CmpOneTrustInit = "cmp-one-trust-init", r.CBLoad = "load", r.CbLoadStyles = "load-styles", r.ArchiveReceipt = "archiveReceipt", r.LogInfo = "log-info", r.LogWarn = "log-warn", r))(W || {}), L = /*           */ ((r) => (r.Success = "success", r.Failure = "fail", r.LogWarn = "log-warn", r.LogInfo = "log-info", r.CbLoadSuccess = "load-show-banner", r.CbLoadError = "no-consent-provider", r.CBHidden = "hidden", r))(L || {});
const y = [
  "success",
  "fail"
  /*         */
], $ = {
  type: "module-init",
  actions: [
    { type: "cmp-init", results: y },
    { type: "cmp-one-trust-init", results: y },
    { type: "load-styles", results: y },
    {
      type: "load",
      results: [
        "no-consent-provider",
        "load-show-banner",
        "hidden"
        /*          */
      ]
    }
  ]
}, v = {
  type: "processing",
  actions: [{ type: "archiveReceipt", results: y }]
}, F = {
  type: "custom",
  actions: [
    { type: "log-info", results: [
      "log-info"
      /*         */
    ] },
    { type: "log-warn", results: [
      "log-warn"
      /*         */
    ] }
  ]
}, T = [
  $,
  v,
  F
], w = window;
w.o_global ||= {}, w.o_util ||= {};
const _ = w.otto ?? {}, R = /*                      */ (r, t, e) => r[t] ?? e, C = (() => {
}), I = /*           */ R(_, "apm", {}), j = /*           */ R(I, "startSpan", C), x = /*           */ R(
  I,
  "captureError",
  C
);
function D(r) {
  return typeof r == "object" && r !== null && "then" in r && typeof r.then == "function";
}
class k {
  constructor(t, e, n) {
    this.type = t, this.team = e, this.service = n;
  }
  spanRegistry = /*           */ new Map();
  async startSpan(t, e, n, s = { blocking: !0 }) {
    const p = this.createType(e);
    try {
      const u = await j(t, p, s);
      if (u)
        return this.spanRegistry.set(t, u), u.addLabels({
          team: this.team,
          service: this.service,
          ...n
        }), {
          end: (f, d) => this.endSpan(t, f, d),
          addLabels: u.addLabels.bind(
            u
          ),
          type: p
        };
    } catch {
    }
  }
  endSpan(t, e, n) {
    try {
      const s = this.spanRegistry.get(t);
      if (!s)
        return;
      s.addLabels({ spanResult: e, ...n }), s.end(), this.spanRegistry.delete(t);
    } catch {
    }
  }
  withSpan(t, e) {
    const {
      name: n,
      action: s,
      extraLabels: p,
      successResult: u,
      failureResult: f,
      extraOptions: d
    } = e;
    return (...S) => {
      const E = this.startSpan(
        n,
        s,
        p,
        d
      ), o = (i = !0) => {
        E.then((a) => {
          const c = i ? u : f ?? u;
          a?.end(c);
        });
      };
      try {
        const i = t(...S);
        return D(i) ? i.then((a) => (o(), a)).catch((a) => (o(!1), Promise.reject(a))) : (o(), i);
      } catch (i) {
        throw o(!1), i;
      }
    };
  }
  createType(t) {
    return `${this.type}.${this.service}.${t}`;
  }
}
function U(r, t, e) {
  const n = T.find(
    ({ type: o }) => o === r
  ), s = new k(r, t, e);
  if (typeof n > "u")
    throw new Error("Unsupported MeasureType: " + r);
  const p = {};
  for (const o of n.actions) {
    const i = o, a = o.type, c = E(r, a);
    Object.assign(p, {
      ...u(a, c),
      ...f(a, c, i),
      ...d(a, c),
      ...S(a, c)
    });
  }
  return p;
  function u(o, i) {
    return {
      [`start${m(o)}`]: async (c) => s.startSpan(i, o, c)
    };
  }
  function f(o, i, a) {
    return {
      [`end${m(o)}`]: (l, g) => {
        const h = a.results.find(
          (A) => A === l
        );
        if (!h)
          throw new Error(
            `Result ${String(l)} not defined for measure action: ${o}`
          );
        return s.endSpan(i, h, g);
      }
    };
  }
  function d(o, i, a) {
    const c = `with${m(o)}`, l = (g, h) => s.withSpan(g, {
      name: i,
      action: o,
      ...h
    });
    return {
      [c]: l
    };
  }
  function S(o, i, a) {
    const c = `run${m(o)}`, l = (g, h) => s.withSpan(g, {
      name: i,
      action: o,
      ...h
    })();
    return {
      [c]: l
    };
  }
  function E(o, i) {
    return `${o}-${i}`;
  }
}
function N(r) {
  return r.charAt(0).toUpperCase() + r.slice(1);
}
function m(r) {
  return r.includes("-") ? r.split("-").map((t) => N(t)).join("") : N(r);
}
class O {
  constructor(t) {
    this.logTransport = t;
  }
  info(t, e) {
    this.callTransport("INFO", t, e);
  }
  warn(t, e) {
    this.callTransport("WARN", t, e);
  }
  error(t, e) {
    this.callTransport("ERROR", t, e);
  }
  callTransport(t, e, n) {
    if (e instanceof Error || typeof e == "string") {
      this.logTransport[t](e, n);
      return;
    }
    try {
      this.logTransport[t](JSON.stringify(e), n);
    } catch (s) {
      console.error("Could not stringify message", s);
    }
  }
}
function M(r) {
  return r == null ? !0 : r instanceof Error ? !1 : typeof r == "string" ? r.trim().length === 0 : Array.isArray(r) ? r.length === 0 : typeof r == "object" ? Object.keys(r).length === 0 : !1;
}
class J {
  constructor(t, e, n) {
    this.team = t, this.service = e, this.logMeasure = n;
  }
  ERROR(t, e) {
    if (M(t))
      return;
    const n = t instanceof Error ? t : new Error(t), s = {
      ...e,
      logLevel: "ERROR",
      logMessage: n.message,
      team: this.team,
      service: this.service,
      ...this.prepareErrorCauseFromError(n)
    };
    x(n, s);
  }
  WARN(t, e) {
    this.logWithLabels("WARN", t, e);
  }
  INFO(t, e) {
    this.logWithLabels("INFO", t, e);
  }
  prepareMessageAsStringOrError(t) {
    return typeof t == "string" ? { logMessage: t } : t instanceof Error ? {
      logMessage: t.toString(),
      ...this.prepareErrorCauseFromError(t)
    } : { logMessage: JSON.stringify(t) };
  }
  prepareErrorCauseFromError(t) {
    return M(t.cause) ? {} : t.cause instanceof Error ? { errorCause: t.cause.toString() } : { errorCause: JSON.stringify(t.cause) };
  }
  logWithLabels(t, e, n) {
    if (M(e))
      return;
    const s = this.prepareMessageAsStringOrError(e);
    this.logWithSpan(t, {
      ...s,
      ...n ?? {},
      logLevel: t,
      team: this.team,
      service: this.service
    });
  }
  logWithSpan(t, e) {
    const n = () => {
    };
    switch (t) {
      case "WARN":
        this.logMeasure.runLogWarn(n, {
          successResult: L.LogWarn,
          extraLabels: e
        });
        break;
      case "INFO":
        this.logMeasure.runLogInfo(n, {
          successResult: L.LogInfo,
          extraLabels: e
        });
        break;
    }
  }
}
function P(r, t, e) {
  if (e)
    return new O(e);
  const n = U(
    b.Custom,
    r,
    t
  ), s = new J(r, t, n);
  return new O(s);
}
function z(r, t, e) {
  const n = new Error(
    `Deprecated method called: '${t}'. ${e ?? ""}`.trim()
  );
  r.error(n);
}
class B {
  INFO(t, e) {
    console.info(this.format(t, e));
  }
  WARN(t, e) {
    console.warn(this.format(t, e));
  }
  ERROR(t, e) {
    console.error(this.format(t, e));
  }
  format(t, e) {
    const n = t instanceof Error ? t.stack || t.message : t;
    return e ? `${n} ${JSON.stringify(e)}` : n;
  }
}
export {
  T as ALL_MEASUREMENTS_DATA,
  W as Action,
  k as ApmAdapter,
  F as CUSTOM_MODEL,
  $ as INIT_MODEL,
  J as LogTransportApm,
  B as LogTransportConsole,
  O as LoggingService,
  b as MeasureType,
  v as PROCESSING_MODEL,
  L as Result,
  P as createLoggingService,
  U as createMeasureServiceFor,
  z as logDeprecatedUsage
};
